import * as Api from '../utils/api'

export default () => Api.doJsonRequest(
  'GET',
  'version.json',
  Api.jsonHeaders,
  {},
  false
)
